import { render, staticRenderFns } from "./tcustomers-add-or-update.vue?vue&type=template&id=f0817e72&"
import script from "./tcustomers-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tcustomers-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports